import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import {NavLink, useNavigate, useParams} from "react-router-dom";
import toast, {Toaster} from "react-hot-toast";
import moment from "moment-timezone";
import MemberSidebar from "../inc/MemberSidebar";
import {confirmAlert} from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import ProposalTeam from "./ProposalTeam";

export default function ProposalGeneral(prop) {
    let navigate = useNavigate();
    let {encode} = useParams();
    let decode = Utils.decodeItem(encode);
    let proposalId = decode.proposalId;
    let isReadOnly = decode.readOnly;

    let member = prop.member;
    let [detail, setDetail] = React.useState(null);
    let [readOnly, setReadOnly] = React.useState(false);

    //Proposal
    let refTitle = React.useRef();
    let refTitle_en = React.useRef();
    let [projectTypeId, setProjectTypeId] = React.useState(Utils.PROJECT_TYPE_MAIN);
    let refProjectsub = React.useRef();
    let [researchTypeId, setResearchTypeId] = React.useState(Utils.PROJECT_RESEARCH_TYPE_NEW);
    let refBudgetYear = React.useRef();
    let refBudgetPrice = React.useRef();
    let refBudgetStart = React.useRef();
    let refSummary = React.useRef();
    let [requestOther, setRequestOther] = React.useState(Utils.REQUEST_OTHER_NO);
    let refPropOtherAgency = React.useRef();
    let refPropOtherTitle = React.useRef();
    let refPropOtherDiff = React.useRef();
    let refKeywords = React.useRef();
    let refKeywords_en = React.useRef();
    let [iscedBroad, setIscedBroad] = React.useState('');
    let [iscedNarrow, setIscedNarrow] = React.useState('');
    let [iscedDetailed, setIscedDetailed] = React.useState('');
    let [oecdMain, setOecdMain] = React.useState('');
    let [oecdSub, setOecdSub] = React.useState('');
    let [oecdRelation, setOecdRelation] = React.useState('');

    let [iscedBroadList, setIscedBroadList] = React.useState(null);
    let [iscedNarrowList, setIscedNarrowList] = React.useState(null);
    let [iscedDetailedList, setIscedDetailedList] = React.useState(null);
    let [oecdMainList, setOecdMainList] = React.useState(null);
    let [oecdSubList, setOecdSubList] = React.useState(null);
    let [oecdRelationList, setOecdRelationList] = React.useState(null);

    let [proposalYearList, setProposalYearList] = React.useState(null);
    let [proposalOperatingList, setProposalOperatingList] = React.useState(null);

    React.useEffect(() => {
        window.scrollTo(0, 0);

        (async function() {
            try {
                const resDetail = await getDetail();
                if(resDetail) {
                    setDetail(resDetail);

                    if([Utils.PROPOSAL_STATUS_APPROVE].includes(resDetail.status)) {
                        setReadOnly(true);
                    }

                    if(isReadOnly) {
                        setReadOnly(isReadOnly);
                    }

                    if(prop !== null && prop.lang === 'en') {
                        resDetail.title = resDetail.title_en;
                    }

                    refTitle.current.value = resDetail.title;
                    refTitle_en.current.value = resDetail.title_en;
                    refProjectsub.current.value = resDetail.projectSub;
                    refBudgetYear.current.value = resDetail.budgetYear;
                    refBudgetPrice.current.value = resDetail.budgetPrice;
                    refBudgetStart.current.value = resDetail.budgetStart;
                    refSummary.current.value = resDetail.summary;
                    refPropOtherAgency.current.value = resDetail.propOtherAgency;
                    refPropOtherTitle.current.value = resDetail.propOtherTitle;
                    refPropOtherDiff.current.value = resDetail.propOtherDiff;
                    refKeywords.current.value = resDetail.keywords;
                    refKeywords_en.current.value = resDetail.keywords_en;

                    setProjectTypeId(resDetail.projectTypeId);
                    setResearchTypeId(resDetail.researchTypeId);
                    setRequestOther(resDetail.requestOther);

                    createProposalYearList(resDetail.proposalYear);
                    createProposalOperatingList(resDetail.proposalOperating);
                }

                const resIscedBroad = await Utils.getIscedBroad();
                setIscedBroadList(resIscedBroad);
                const resOecdMain = await Utils.getOecdMain();
                setOecdMainList(resOecdMain);

                document.title = 'ทุนวิจัย Scholarship | NCSA - ' + resDetail.title;
            } catch (e) {
                //
            }
        })();
    }, []);

    React.useEffect(() => {
        (async function() {
            try {
                if(detail.iscedBroad) {
                    setIscedBroad(detail.iscedBroad);
                    const resIscedNarrow = await Utils.getIscedNarrow(detail.iscedBroad);
                    if(resIscedNarrow) {
                        setIscedNarrowList(resIscedNarrow);
                        setIscedNarrow(detail.iscedNarrow);

                        const resIscedDetail = await Utils.getIscedDetailed(detail.iscedNarrow);
                        if(resIscedDetail) {
                            setIscedDetailedList(resIscedDetail);
                            setIscedDetailed(detail.iscedDetailed);
                        }
                    }
                }

                if(detail.oecdMain) {
                    setOecdMain(detail.oecdMain);
                    const resOecdSub = await Utils.getOecdSub(detail.oecdMain);
                    if(resOecdSub) {
                        setOecdSubList(resOecdSub);
                        setOecdSub(detail.oecdSub);

                        const resOecdRelation = await Utils.getOecdRelation(detail.oecdSub);
                        if(resOecdRelation) {
                            setOecdRelationList(resOecdRelation);
                            setOecdRelation(detail.oecdRelation);
                        }
                    }
                }
            } catch (e) {
                //
            }
        })();
    }, [detail]);

    async function getDetail() {
        const response = await fetch(Config.apiUrl +'/proposal/viewProposal', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                id: proposalId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onCancel = () => {
        //if(readOnly) {
        //    navigate((prop.lang === 'en' ? '/en':'') + '/proposalApprove');
        //}
        //else {
        navigate((prop.lang === 'en' ? '/en':'') + '/proposal');
        //}
    };

    const onSubmit = () => {
        confirmAlert({
            title: 'แจ้งเตือน',
            message: 'ต้องการบันทึกข้อมูล ?',
            buttons: [
                {
                    label: 'ตกลง',
                    onClick: async () => {
                        let title = refTitle.current.value;
                        let title_en = refTitle_en.current.value;
                        let projectSub = refProjectsub.current.value;
                        let budgetYear = refBudgetYear.current.value;
                        let budgetPrice = refBudgetPrice.current.value;
                        let budgetStart = refBudgetStart.current.value;
                        let summary = refSummary.current.value;
                        let propOtherAgency = refPropOtherAgency.current.value;
                        let propOtherTitle = refPropOtherTitle.current.value;
                        let propOtherDiff = refPropOtherDiff.current.value;
                        let keywords = refKeywords.current.value;
                        let keywords_en = refKeywords_en.current.value;

                        if(title === '') {
                            toast.error(prop.lang === 'en' ? 'Please specify Project name/research plan (Thai)':'กรุณาระบุ ชื่อโครงการ/แผนงานวิจัย (ภาษาไทย)');
                            refTitle.current.focus();
                        }
                        else if(title_en === '') {
                            toast.error(prop.lang === 'en' ? 'Please specify Project name/research plan (English)':'กรุณาระบุ ชื่อโครงการ/แผนงานวิจัย (English)');
                            refTitle_en.current.focus();
                        }
                        else if(projectTypeId === Utils.PROJECT_TYPE_SET && projectSub === '') {
                            toast.error(prop.lang === 'en' ? 'Project Sub Name':'ชื่อโครงการวิจัยย่อย');
                            refProjectsub.current.focus();
                        }
                        else {
                            let param = {
                                proposalId: proposalId,
                                title: title,
                                title_en: title_en,
                                projectTypeId: projectTypeId,
                                projectSub: projectTypeId === Utils.PROJECT_TYPE_SET ? projectSub : null,
                                researchTypeId: researchTypeId,
                                budgetYear: budgetYear,
                                budgetPrice: budgetPrice,
                                budgetStart: researchTypeId === Utils.PROJECT_RESEARCH_TYPE_CONTINUE ? budgetStart : null,
                                summary: summary,
                                requestOther: requestOther,
                                propOtherAgency: requestOther === Utils.REQUEST_OTHER_YES ? propOtherAgency : null,
                                propOtherTitle: requestOther === Utils.REQUEST_OTHER_YES ? propOtherTitle : null,
                                propOtherDiff: requestOther === Utils.REQUEST_OTHER_YES ? propOtherDiff : null,
                                keywords: keywords_en,
                                keywords_en: keywords,
                                iscedBroad: iscedBroad,
                                iscedNarrow: iscedNarrow,
                                iscedDetailed: iscedDetailed,
                                oecdMain: oecdMain,
                                oecdSub: oecdSub,
                                oecdRelation: oecdRelation,
                                proposalYearList: proposalYearList,
                                proposalOperatingList: proposalOperatingList,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };
                            const result = await updateProposal(param);

                            if(result) {
                                if(result.status === 'success') {
                                    toast.success(prop.lang === 'en' ? 'General information has been recorded successfully.':'บันทึกข้อมูล ส่วนที่ 1 ข้อมูลทั่วไป เรียบร้อย');
                                    setTimeout(function () {
                                        navigate((prop.lang === 'en' ? '/en/':'') + '/proposal');
                                    }, 1500);
                                }
                                else {
                                    toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                                }
                            }
                            else {
                                toast.error(prop.lang === 'en' ? 'Sorry, Service is not available at this time. Please contact the administrator.':'ขออภัย ทำรายการได้ในขณะนี้ กรุณาติดต่อผู้่ดูแลระบบ');
                            }
                        }
                    }
                },
                {
                    label: 'ยกเลิก',
                    onClick: () => {}
                }
            ]
        });
    };

    async function updateProposal(param) {
        const response = await fetch(Config.apiUrl +'/proposal/updateProposal', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onChangeIscedBroad = async (x) => {
        setIscedBroad(null);
        setIscedNarrow(null);
        setIscedNarrowList(null);
        setIscedDetailed(null);
        setIscedDetailedList(null);

        let boardId = x.target.value;
        if(boardId) {
            setIscedBroad(boardId);
            const resIscedNarrow = await Utils.getIscedNarrow(boardId);
            setIscedNarrowList(resIscedNarrow);
        }
    };
    const onChangeIscedNarrow = async (x) => {
        setIscedNarrow(null);
        setIscedDetailed(null);
        setIscedDetailedList(null);

        let narrowId = x.target.value;
        if(narrowId) {
            setIscedNarrow(narrowId);
            const resIscedDetailed = await Utils.getIscedDetailed(narrowId);
            setIscedDetailedList(resIscedDetailed);
        }
    };
    const onChangeIscedDetail = async (x) => {
        setIscedDetailed(null);
        let detailedId = x.target.value;
        if(detailedId) {
            setIscedDetailed(detailedId);
        }
    };

    const onChangeOecdMain = async (x) => {
        setOecdMain(null);
        setOecdSub(null);
        setOecdSubList(null);
        setOecdRelation(null);
        setOecdRelationList(null);

        let oecdMainId = x.target.value;
        if(oecdMainId) {
            setOecdMain(oecdMainId);
            const resOecdSub = await Utils.getOecdSub(oecdMainId);
            setOecdSubList(resOecdSub);
        }
    };
    const onChangeOecdSub = async (x) => {
        setOecdSub(null);
        setOecdRelation(null);
        setOecdRelationList(null);

        let oecdSubId = x.target.value;
        if(oecdSubId) {
            setOecdSub(oecdSubId);
            const resOecdRelation = await Utils.getOecdRelation(oecdSubId);
            setOecdRelationList(resOecdRelation);
        }
    };
    const onChangeOecdRelation = async (x) => {
        setOecdRelation(null);
        let oecdRelationId = x.target.value;
        if(oecdRelationId) {
            setOecdRelation(oecdRelationId);
        }
    };

    //ProposalYear
    const createProposalYearList = (listing) => {
        let arr = [];
        let count = refBudgetYear.current.value;
        for(let i=0;i<count;i++) {
            if(listing !== null && i < listing.length) {
                let obj = {
                    fiscalYear: listing[i].fiscalYear ?? null,
                    budgetPrice: listing[i].budgetPrice
                };
                arr.push(obj);
            }
            else {
                let obj = {
                    fiscalYear: null,
                    budgetPrice: null
                };
                arr.push(obj);
            }
        }
        setProposalYearList(arr);
    };
    const onChangeBudgetYear = () => {
        createProposalYearList(detail.proposalYear);
        createProposalOperatingList(detail.proposalOperating);
    };
    const updateProposalYear = (index, value) => {
        proposalYearList[index].fiscalYear = value;
        setProposalYearList(proposalYearList);
    };
    const updateProposalYearBudget = (index, value) => {
        proposalYearList[index].budgetPrice = value;
        setProposalYearList(proposalYearList);
    };

    //ProposalOperating
    const createProposalOperatingList = (listing) => {
        let arr = [];
        let count = refBudgetYear.current.value;
        for(let i=0;i<count;i++) {
            if(listing !== null && i < listing.length) {
                let obj = {
                    fiscalYear: listing[i].fiscalYear ?? null,
                    comparePlan: listing[i].comparePlan ?? null,
                    budgetAllocate: listing[i].budgetAllocate ?? null,
                    budgetActual: listing[i].budgetActual ?? null,
                    budgetRatio: listing[i].budgetRatio ?? null
                };
                arr.push(obj);
            }
            else {
                let obj = {
                    fiscalYear: null,
                    comparePlan: null,
                    budgetAllocate: null,
                    budgetActual: null,
                    budgetRatio: null
                };
                arr.push(obj);
            }
        }
        setProposalOperatingList(arr);
    };
    const updateOperatingYear = (index, value) => {
        proposalOperatingList[index].fiscalYear = value;
        setProposalOperatingList(proposalOperatingList);
    };
    const updateOperatingComparePlan = (index, value) => {
        proposalOperatingList[index].comparePlan = value;
        setProposalOperatingList(proposalOperatingList);
    };
    const updateOperatingBudgetAllocate = (index, value) => {
        proposalOperatingList[index].budgetAllocate = value;
        setProposalOperatingList(proposalOperatingList);
    };
    const updateOperatingBudgetActual = (index, value) => {
        proposalOperatingList[index].budgetActual = value;
        setProposalOperatingList(proposalOperatingList);
    };
    const updateOperatingBudgetRatio = (index, value) => {
        proposalOperatingList[index].budgetRatio = value;
        setProposalOperatingList(proposalOperatingList);
    };

    return (
        <>
            <div className="section">
                <div className="container has-sidebar">
                    <div className="sidebar">
                        <MemberSidebar active="proposal" lang={prop.lang} />
                    </div>
                    <div className="content">
                        <div className="card-infos has-shadow-black" data-aos="fade-in">
                            <div className="card-body p-0 px-xxl-3">
                                <h2 className="h3 text-center">{prop.lang === 'en' ? 'Full Proposal':'ยื่นแบบฟอร์มข้อเสนอโครงการฉบับสมบูรณ์ (Full Proposal)'}</h2>
                                <div className="text-center">{prop.lang === 'en' ? 'Strategic Research Project (Strategic Fund; SF): Research Project Type':'โครงการวิจัยเชิงกลยุทธ์ (Strategic Fund; SF) : ประเภทโครงการวิจัย'}</div>
                                <h3 className="mt-2 text-center">{prop.lang === 'en' ? 'Research Fund Name ':'ชื่อทุนวิจัย '} : {prop.lang === 'en' ? detail?.scholarship.title_en : detail?.scholarship.title}</h3>

                                <h3 className="title-bar mt-4 mb-2">{prop.lang === 'en' ? 'Part 1. General Information':'ส่วนที่ 1 ข้อมูลทั่วไป'}</h3>
                                <h4 className="title-line-left mb-2">1. {prop.lang === 'en' ? 'Project name/research plan':'ชื่อโครงการ/แผนงานวิจัย'}</h4>
                                <div className="row g-4">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Thai':'ภาษาไทย'} <span className="star">*</span></h6>
                                            <input type="text" className="form-control" ref={refTitle} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'English':'ภาษาอังกฤษ'} <span className="star">*</span></h6>
                                            <input type="text" className="form-control" ref={refTitle_en} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Project Type':'ประเภทโครงการ'} <span className="star">*</span></h6>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-check lg">
                                                        <input className="form-check-input" type="radio" value="" id="projectTypeId1" name="projectTypeId1" onChange={e => setProjectTypeId(Utils.PROJECT_TYPE_MAIN)} checked={Utils.PROJECT_TYPE_MAIN === projectTypeId} disabled={readOnly} />
                                                        <label className="form-check-label" htmlFor="projectTypeId1">{prop.lang === 'en' ? 'Project Main':'โครงการวิจัย'}</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-check lg">
                                                        <input className="form-check-input" type="radio" value="" id="projectTypeId2" name="projectTypeId2" onChange={e => setProjectTypeId(Utils.PROJECT_TYPE_SET)} checked={Utils.PROJECT_TYPE_SET === projectTypeId} disabled={readOnly} />
                                                        <label className="form-check-label" htmlFor="projectTypeId2">{prop.lang === 'en' ? 'Project Set':'ชุดโครงการวิจัย'}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <h4 className="title-line-left mt-5 mb-3">2. {prop.lang === 'en' ? 'Sub-research projects under the research project package (in case of selecting the project package type)':'โครงการวิจัยย่อยภายใต้ชุดโครงการวิจัย (กรณีเลือกประเภทโครงชุดโครงการ)'}</h4>
                                <div className="row g-4">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Project Sub Name':'ชื่อโครงการวิจัยย่อย'} <span className="star">*</span></h6>
                                            <input type="text" className="form-control" ref={refProjectsub} maxLength={250} disabled={Utils.PROJECT_TYPE_MAIN === projectTypeId} disabled={readOnly} />
                                        </div>
                                    </div>
                                </div>

                                <h4 className="title-line-left mt-5 mb-3">3. {prop.lang === 'en' ? 'Research Project Type':'ลักษณะโครงการวิจัย'}</h4>
                                <div className="row g-4">
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-check lg">
                                                    <input className="form-check-input" type="radio" value="" id="researchTypeId1" name="researchTypeId1" onChange={e => setResearchTypeId(Utils.PROJECT_RESEARCH_TYPE_NEW)} checked={Utils.PROJECT_RESEARCH_TYPE_NEW === researchTypeId} disabled={readOnly} />
                                                    <label className="form-check-label" htmlFor="researchTypeId1">{prop.lang === 'en' ? 'New Project':'โครงการใหม่'}</label>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-check lg">
                                                    <input className="form-check-input" type="radio" value="" id="researchTypeId2" name="researchTypeId2" onChange={e => setResearchTypeId(Utils.PROJECT_RESEARCH_TYPE_CONTINUE)} checked={Utils.PROJECT_RESEARCH_TYPE_CONTINUE === researchTypeId} disabled={readOnly} />
                                                    <label className="form-check-label" htmlFor="researchTypeId2">{prop.lang === 'en' ? 'Ongoing Project':'โครงการต่อเนื่อง'}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-md-6">
                                        <div className="form-group">
                                            <div>
                                                {
                                                    Utils.PROJECT_RESEARCH_TYPE_CONTINUE === researchTypeId ?
                                                    prop.lang === 'en' ? 'From the past fiscal year, operations':'จากปีงบประมาณที่ผ่านมา ดำเนินงาน' : prop.lang === 'en' ? 'That will start operations in the proposed year':'ที่เริ่มดำเนินการในปีที่เสนอขอ ดำเนินงาน'
                                                }
                                            </div>
                                            <div className="input-group">
                                                <input type="number" className="form-control text-center" ref={refBudgetYear} maxLength={11} onChange={onChangeBudgetYear} min={0} max={10} disabled={readOnly} />
                                                <span className="input-group-text" id="basic-addon1">{prop.lang === 'en' ? 'Year':'ปี'}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-md-6">
                                        <div className="form-group">
                                            <div>{prop.lang === 'en' ? 'Total budget including projects':'งบประมาณรวมทั้งโครงการ'}</div>
                                            <div className="input-group">
                                                <input type="number" className="form-control text-center" ref={refBudgetPrice} maxLength={11} disabled={readOnly} />
                                                <span className="input-group-text" id="basic-addon1">{prop.lang === 'en' ? 'THB':'บาท'}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"col-xl-4 col-md-6" + (Utils.PROJECT_RESEARCH_TYPE_CONTINUE === researchTypeId ? '':' d-none')}>
                                        <div className="form-group">
                                            <div>{prop.lang === 'en' ? 'Start receiving the annual budget':'เริ่มรับงบประมาณปี'}</div>
                                            <div className="input-group">
                                                <input type="number" className="form-control text-center" ref={refBudgetStart} maxLength={4} disabled={readOnly} />
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        proposalYearList !== null ?
                                            proposalYearList.map((row, index) => {
                                                return (
                                                    <div key={index} className="col-12">
                                                        <div className="form-group">
                                                            <div className="input-group">
                                                                <span className="input-group-text">{prop.lang === 'en' ? 'Year':'ปีงบประมาณ'}</span>
                                                                <input type="number" className="form-control text-center" min={0} maxLength={4} onChange={e => updateProposalYear(index, e.target.value)} defaultValue={row.fiscalYear ?? null} disabled={readOnly} />
                                                                <span className="input-group-text">{prop.lang === 'en' ? 'Budget':'งบประมาณ'}</span>
                                                                <input type="number" className="form-control text-center" min={0} maxLength={11} onChange={e => updateProposalYearBudget(index, e.target.value)} defaultValue={row.budgetPrice ?? null} disabled={readOnly} />
                                                                <span className="input-group-text">{prop.lang === 'en' ? 'THB':'บาท'}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            }) : ''

                                    }

                                    <div className={"col-12" + (Utils.PROJECT_RESEARCH_TYPE_CONTINUE === researchTypeId ? '':' d-none')}>
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Past performance (in the case of ongoing projects)':'ผลการดำเนินที่ผ่านมา (กรณีที่เป็นโครงการต่อเนื่อง)'}</h6>

                                            <div className="table-responsive mt-1">
                                                <table className="table table-info table-hover text-center">
                                                    <thead>
                                                        <tr style={{fontSize: '12px'}}>
                                                            <th>{prop.lang === 'en' ? 'Year':'ปีงบประมาณ'}</th>
                                                            <th>{prop.lang === 'en' ? 'Year':<>ผลการดำเนินงาน<br />เทียบกับแผนที่ตั้งไว้ (%)</>}</th>
                                                            <th>{prop.lang === 'en' ? 'Year':<>งบประมาณ<br />ที่ได้รับจัดสรร (บาท)</>}</th>
                                                            <th>{prop.lang === 'en' ? 'Year':<>งบประมาณ<br />ที่ใช้จริง (บาท)</>}</th>
                                                            <th>{prop.lang === 'en' ? 'Year':<>สัดส่วนงบประมาณ<br />ที่ใช้จริง (%)</>}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    {
                                                        proposalOperatingList !== null ?
                                                            proposalOperatingList.map((row, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <td className="text-center">
                                                                            <input type="number" className="form-control text-center" min={0} maxLength={4} onChange={e => updateOperatingYear(index, e.target.value)} defaultValue={row.fiscalYear ?? null} disabled={readOnly} />
                                                                        </td>
                                                                        <td className="text-center">
                                                                            <input type="number" className="form-control text-center" min={0} maxLength={11} onChange={e => updateOperatingComparePlan(index, e.target.value)} defaultValue={row.comparePlan ?? null} disabled={readOnly} />
                                                                        </td>
                                                                        <td className="text-center">
                                                                            <input type="number" className="form-control text-center" min={0} maxLength={11} onChange={e => updateOperatingBudgetAllocate(index, e.target.value)} defaultValue={row.budgetAllocate ?? null} disabled={readOnly} />
                                                                        </td>
                                                                        <td className="text-center">
                                                                            <input type="number" className="form-control text-center" min={0} maxLength={11} onChange={e => updateOperatingBudgetActual(index, e.target.value)} defaultValue={row.budgetActual ?? null} disabled={readOnly} />
                                                                        </td>
                                                                        <td className="text-center">
                                                                            <input type="number" className="form-control text-center" min={0} maxLength={11} onChange={e => updateOperatingBudgetRatio(index, e.target.value)} defaultValue={row.budgetRatio ?? null} disabled={readOnly} />
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            }) : <tr><td colSpan={5}></td></tr>
                                                    }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Summary':'สรุปผลการดำเนินงานที่ผ่านมา'}</h6>
                                            <textarea className="form-control" ref={refSummary} maxLength={1000} disabled={readOnly}></textarea>
                                        </div>
                                    </div>
                                </div>

                                <h4 className="title-line-left mt-5 mb-3">4. {prop.lang === 'en' ? 'Projects requesting funding from other agencies':'โครงการยื่นเสนอขอรับทุนจากหน่วยงานอื่น'}</h4>
                                <div className="row g-4">
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-check lg">
                                                    <input className="form-check-input" type="radio" value="" id="requestOther1" name="requestOther1" onChange={e => setRequestOther(Utils.REQUEST_OTHER_NO)} checked={Utils.REQUEST_OTHER_NO === requestOther} disabled={readOnly} />
                                                    <label className="form-check-label" htmlFor="requestOther1">{prop.lang === 'en' ? 'No offer made':'ไม่มีการยื่นเสนอ'}</label>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-check lg">
                                                    <input className="form-check-input" type="radio" value="" id="requestOther2" name="requestOther2" onChange={e => setRequestOther(Utils.REQUEST_OTHER_YES)} checked={Utils.REQUEST_OTHER_YES === requestOther} disabled={readOnly} />
                                                    <label className="form-check-label" htmlFor="requestOther2">{prop.lang === 'en' ? 'A proposal has been submitted':'มีการยื่นเสนอ'}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"col-12" + (Utils.REQUEST_OTHER_YES === requestOther ? '':' d-none')}>
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Agency/Institution':'ระบุหน่วยงาน/สถาบันที่ยื่น'}</h6>
                                            <input type="text" className="form-control" ref={refPropOtherAgency} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className={"col-12" + (Utils.REQUEST_OTHER_YES === requestOther ? '':' d-none')}>
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Project Name':' ชื่อโครงการ'}</h6>
                                            <input type="text" className="form-control" ref={refPropOtherTitle} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className={"col-12" + (Utils.REQUEST_OTHER_YES === requestOther ? '':' d-none')}>
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Differences from this project':' ระบุความแตกต่างจากโครงการนี้'}</h6>
                                            <input type="text" className="form-control" ref={refPropOtherDiff} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                </div>

                                <h4 className="title-line-left mt-5 mb-3">5. {prop.lang === 'en' ? 'Keywords (no more than 5 words) separated by ,':'คำสำคัญ (Keywords) (กำหนดไม่เกิน 5 คำ) คั่นด้วย ,'}</h4>
                                <div className="row g-4">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Thai':'ภาษาไทย'}</h6>
                                            <input type="text" className="form-control" ref={refKeywords} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'English':'ภาษาอังกฤษ'}</h6>
                                            <input type="text" className="form-control" ref={refKeywords_en} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                </div>

                                <h4 className="title-line-left mt-5 mb-3">6. {prop.lang === 'en' ? 'ISCED':'ISCED'}</h4>
                                <div className="row g-4">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'ISCED Broad field ':'ISCED Broad field '}</h6>
                                            <select className="form-select" onChange={onChangeIscedBroad} value={iscedBroad} disabled={readOnly}>
                                                <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                                {
                                                    iscedBroadList !== null && iscedBroadList.count > 0 ?
                                                        iscedBroadList.rows.map((row, index) => {
                                                            return (
                                                                <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                            )
                                                        }) : ''
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'ISCED Narrow field ':'ISCED Narrow field '}</h6>
                                            <select className="form-select" onChange={onChangeIscedNarrow} value={iscedNarrow} disabled={readOnly}>
                                                <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                                {
                                                    iscedNarrowList !== null && iscedNarrowList.count > 0 ?
                                                        iscedNarrowList.rows.map((row, index) => {
                                                            return (
                                                                <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                            )
                                                        }) : ''
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'ISCED Detailed field ':'ISCED Detailed field '}</h6>
                                            <select className="form-select" onChange={onChangeIscedDetail} value={iscedDetailed} disabled={readOnly}>
                                                <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                                {
                                                    iscedDetailedList !== null && iscedDetailedList.count > 0 ?
                                                        iscedDetailedList.rows.map((row, index) => {
                                                        return (
                                                            <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                        )
                                                    }) : ''
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <h4 className="title-line-left mt-5 mb-3">7. {prop.lang === 'en' ? 'OECD':'สาขาการวิจัย (เลือกจากฐานข้อมูลในระบบ)'}</h4>
                                <div className="row g-4">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Main OECD':'สาขาการวิจัยหลัก OECD'}</h6>
                                            <select className="form-select" onChange={onChangeOecdMain} value={oecdMain} disabled={readOnly}>
                                                <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                                {
                                                    oecdMainList !== null && oecdMainList.count > 0 ?
                                                        oecdMainList.rows.map((row, index) => {
                                                            return (
                                                                <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                            )
                                                        }) : ''
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Sub OECD':'สาขาการวิจัยย่อย OECD'}</h6>
                                            <select className="form-select" onChange={onChangeOecdSub} value={oecdSub} disabled={readOnly}>
                                                <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                                {
                                                    oecdSubList !== null && oecdSubList.count > 0 ?
                                                        oecdSubList.rows.map((row, index) => {
                                                            return (
                                                                <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                            )
                                                        }) : ''
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Relation':'สาขาที่เกี่ยวข้อง'}</h6>
                                            <select className="form-select" onChange={onChangeOecdRelation} value={oecdRelation} disabled={readOnly}>
                                                <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                                {
                                                    oecdRelationList !== null && oecdRelationList.count > 0 ?
                                                        oecdRelationList.rows.map((row, index) => {
                                                            return (
                                                                <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                            )
                                                        }) : ''
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <h4 className="title-line-left mt-5 mb-3">8. {prop.lang === 'en' ? 'Research Team':'รายละเอียดของคณะผู้วิจัย'}</h4>
                                <ProposalTeam proposalId={proposalId} member={member} readOnly={readOnly} />

                                <div className="py-3"><hr /></div>
                                <div className="buttons gap-15 py-0 mb-4">
                                    <button className="btn btn-gray w-130" type="button" onClick={onCancel}>{prop.lang === 'en' ? 'Prev':'ย้อนกลับ'}</button>
                                    {
                                        !readOnly ? <button className="btn btn-secondary w-130" type="button" onClick={onSubmit}>{prop.lang === 'en' ? 'Save':'บันทึกข้อมูล'}</button> : ''
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="top-right" />
        </>
    );
} 